import { urls } from './urls';

// Explore tabs, in header-menu order. The id is the feed filter and the ?type= value.
export const EXPLORE_SECTIONS = [
  { id: 'artworks', label: 'Artworks', icon: '🎨' },
  { id: 'galleries', label: 'Galleries', icon: '🏛️' },
  { id: 'exhibitions', label: 'Exhibitions', icon: '🖼️' },
  { id: 'articles', label: 'Articles', icon: '📰' },
  { id: 'trending', label: 'Trending', icon: '🔥' }
];

export const exploreSectionUrl = (id) => `${urls.app.explore}?type=${id}`;
